import { ROLES } from '../../../../../constants';

import templateActiveIcon from '../../assets/icons/blue/template_blue.svg';
import templateIcon from '../../assets/icons/grey/template_grey.svg';
import caseTemplateActiveIcon from '../../assets/icons/blue/case_template_blue.svg';
import caseTemplateIcon from '../../assets/icons/grey/case_template_grey.svg';
import projectsActiveIcon from '../../assets/icons/blue/projects_blue.svg';
import projectsIcon from '../../assets/icons/grey/projects_grey.svg';
import oneIcon from '../../assets/icons/one.png';

export default [
  {
    name: 'One',
    icon: oneIcon,
    items: [
      {
        name: 'content-templates',
        titleKey: 'Content Templates',
        icon: templateIcon,
        activeIcon: templateActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/one/content-templates',
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
      },
      {
        name: 'milestone-groups',
        titleKey: 'Milestone Groups',
        icon: templateIcon,
        activeIcon: templateActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/one/milestone-groups',
        roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.SUPERUSER],
      },
      {
        name: 'Projects',
        titleKey: 'Projects',
        icon: projectsIcon,
        activeIcon: projectsActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/one/projects',
        roles: '*',
      },
    ],
  },
];
